/** Solid primary action — matches screenshot "View Application". */
export const residentHeaderPrimaryActionClass =
  'inline-flex max-w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-[#1597ff] px-4 py-2.5 text-sm font-semibold leading-tight text-white shadow-[0px_2px_4px_rgba(0,0,0,0.1)] transition hover:bg-[#0d7acc] focus-visible:outline focus-visible:ring-2 focus-visible:ring-[#1597ff]/50 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50'

/** Outlined secondary action — matches screenshot "Download Access Confirmation". */
export const residentHeaderOutlineActionClass =
  'inline-flex max-w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-[#1597ff] bg-white px-4 py-2.5 text-sm font-semibold leading-tight text-[#1597ff] shadow-sm transition hover:bg-[#eef7ff] focus-visible:outline focus-visible:ring-2 focus-visible:ring-[#1597ff]/50 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50'

/** Solid danger action — matches resident list "Mark Rent Not Paid & Open Reimbursement". */
export const residentHeaderDangerActionClass =
  'inline-flex max-w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-[#dc2626] px-4 py-2.5 text-sm font-semibold leading-tight text-white shadow-[0px_2px_4px_rgba(0,0,0,0.1)] transition hover:bg-[#b91c1c] focus-visible:outline focus-visible:ring-2 focus-visible:ring-[#dc2626]/50 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50'

/** @deprecated Prefer `residentHeaderPrimaryActionClass` / `residentHeaderOutlineActionClass`. */
export const residentHeaderActionButtonClass = residentHeaderPrimaryActionClass

/** Tone palette for the resident header info cards. */
export const RESIDENT_HEADER_TONE_STYLES = {
  blue: {
    card: 'border-[#e3f0fb] bg-[#f7fbff]',
    iconWrap: 'bg-[#1597ff] text-white',
    title: 'text-[#5bb3ff]',
    rule: 'bg-[#1597ff]/25',
  },
  purple: {
    card: 'border-[#ebe4ff] bg-[#faf8ff]',
    iconWrap: 'bg-[#7c3aed] text-white',
    title: 'text-[#9b6ef0]',
    rule: 'bg-[#7c3aed]/25',
  },
  orange: {
    card: 'border-[#fcecd6] bg-[#fffbf6]',
    iconWrap: 'bg-[#ea580c] text-white',
    title: 'text-[#f08a4a]',
    rule: 'bg-[#ea580c]/25',
  },
  red: {
    card: 'border-[#fde2e2] bg-[#fff7f7]',
    iconWrap: 'bg-[#ef4444] text-white',
    title: 'text-[#f87171]',
    rule: 'bg-[#ef4444]/25',
  },
} as const
